import { SporsmalType } from '../../types/generated-types';
import { Kontaktinfofelt } from '../kontaktinfo/kontaktinfofelt';
import { CurrentSporsmal } from '../reducer/current-steg';
import { KontaktInfoInvolvertSporsmal } from '../reducer/sporsmalsflyt-types';
import {
    isValidFodselsdato,
    MAKSLENGDER,
    validateInputLengde,
    validateIsNonEmptyText,
    validateMobilnummer,
} from '../validation/validate';

export interface CurrentKontaktInfoInvolvertSporsmal {
    type: SporsmalType.KontaktInfoInvolvert;
    sporsmal: KontaktInfoInvolvertSporsmal;
    navn: string;
    mobilnummer: string;
    adresse: string;
    fodselsdato: string;
}

export const validateOptionalField = (value: string, type: Kontaktinfofelt) => {
    if (!validateIsNonEmptyText(value)) {
        return true;
    }

    switch (type) {
        case Kontaktinfofelt.Mobilnummer:
            return validateMobilnummer(value);

        case Kontaktinfofelt.Adresse:
            return validateInputLengde(MAKSLENGDER.lokasjon, value);

        case Kontaktinfofelt.Fodselsdato:
            return isValidFodselsdato(value);

        default:
            return false;
    }
};

export const isKontaktInfoInvolvertSporsmal = (
    currentSporsmal: CurrentSporsmal,
): currentSporsmal is CurrentKontaktInfoInvolvertSporsmal => currentSporsmal.type === SporsmalType.KontaktInfoInvolvert;

export type BesvartKontaktInfoInvolvertSporsmal = CurrentKontaktInfoInvolvertSporsmal;

export const isKontaktInfoInvolvertValid = (currentSporsmal: CurrentKontaktInfoInvolvertSporsmal): boolean => {
    return (
        validateIsNonEmptyText(currentSporsmal.navn) &&
        validateOptionalField(currentSporsmal.mobilnummer, Kontaktinfofelt.Mobilnummer) &&
        validateOptionalField(currentSporsmal.adresse, Kontaktinfofelt.Adresse) &&
        validateOptionalField(currentSporsmal.fodselsdato, Kontaktinfofelt.Fodselsdato)
    );
};

const updateKontaktInfoInvolvertSporsmal = (
    opprinneligKontaktinfosvar: CurrentKontaktInfoInvolvertSporsmal,
    felt: Kontaktinfofelt,
    svarTekst: string,
): CurrentKontaktInfoInvolvertSporsmal => {
    switch (felt) {
        case Kontaktinfofelt.Navn:
            return { ...opprinneligKontaktinfosvar, navn: svarTekst };
        case Kontaktinfofelt.Mobilnummer:
            return { ...opprinneligKontaktinfosvar, mobilnummer: svarTekst };
        case Kontaktinfofelt.Adresse:
            return { ...opprinneligKontaktinfosvar, adresse: svarTekst };
        case Kontaktinfofelt.Fodselsdato:
            return { ...opprinneligKontaktinfosvar, fodselsdato: svarTekst };
        default:
            return opprinneligKontaktinfosvar;
    }
};

export const updateCurrentKontaktInfoInvolvertSporsmal = (
    currentSporsmal: CurrentSporsmal,
    felt: Kontaktinfofelt,
    svarTekst: string,
): CurrentSporsmal => {
    if (isKontaktInfoInvolvertSporsmal(currentSporsmal)) {
        return updateKontaktInfoInvolvertSporsmal(currentSporsmal, felt, svarTekst);
    }
    return currentSporsmal;
};
